<template>
  <div class="flex wrap" v-if="item">
    <component
      style="min-width: 320px"
      class="flexy"
      :id="
        'iitem_' + type.norm() + '_' + iitemid.norm() ||
        $route.params.iitemid.norm()
      "
      :class="
        'iitem_' + type.norm() + '_' + iitemid.norm() ||
        $route.params.iitemid.norm()
      "
      v-if="
        $store.state.app.forms &&
        $store.state.app.forms[type || $route.params.type]
      "
      :is="'iitem'"
      :type="type || $route.params.type"
      :iitemid="iitemid || $route.params.iitemid"
    ></component>
    <div class="wrap flex" style="max-height: calc(100vh - 200px); overflow-y: auto;">
      <comments

        
        v-if="enabledpowers.comments"
        :key="'comment' + $store.state.componentKeys.comments"
        :commentsid="iitemid || $route.params.iitemid"
      ></comments>
      <reviews
        class="flexz"
        style="
          border: solid rgba(0, 0, 0, 0.2);
          border-top-width: 0px;
          border-left-width: 1px;
          border-right-width: 1px;
        "
        v-if="enabledpowers.reputation"
        :key="'review' + $store.state.componentKeys.reviews"
        :repid="iitemid || $route.params.iitemid"
        :type="type"
      ></reviews>
    </div>
  </div>
</template>

<script>
export default {
  name: "single",
  computed: {
    item() {
      return (
        (this.$store.state.items[this.type || this.$route.params.type] &&
          this.$store.state.items[this.type || this.$route.params.type][
            this.iitemid || this.$route.params.iitemid
          ]) ||
        {}
      );
    },
    enabledpowers() {
      const type = this.type || this.$route.params.type;
      if (
        type &&
        this.$store.state.app.basics.items[
          this.$store.state.app.itemTypes.indexOf(type)
        ]
      ) {
        return {
          comments:
            this.$store.state.app.basics.items[
              this.$store.state.app.itemTypes.indexOf(type)
            ].comments,
          reputation:
            this.$store.state.app.basics.items[
              this.$store.state.app.itemTypes.indexOf(type)
            ].reputation,
        };
      } else return {}
    }
  },
  data() {
    return {
      showError: false,
    };
  },
  mounted() {},
  props: { type: { type: String }, iitemid: { type: String } },
};
</script>